import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { MAIN_REGISTRATION_FORM } from "@/data/eventData";

const RegisterStrip = ({ text = "Two days. Seven committees. One seat with your name on it." }) => (
    <section data-testid="register-strip" className="border-t border-cream/5 bg-coal/50 py-16 md:py-20">
        <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-8 px-5 md:flex-row md:items-center md:px-10">
            <Reveal>
                <p className="max-w-xl font-serif text-3xl font-light italic leading-snug text-cream md:text-4xl">
                    {text}
                </p>
            </Reveal>
            <Reveal delay={0.1}>
                <a
                    href={MAIN_REGISTRATION_FORM}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="strip-register-btn"
                    className="group inline-flex w-full items-center justify-center gap-3 bg-crimson px-9 py-4 font-sans text-xs font-semibold uppercase tracking-[0.25em] text-cream transition-colors duration-300 hover:bg-scarlet md:w-auto"
                >
                    Register Now
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </a>
            </Reveal>
        </div>
    </section>
);

export default RegisterStrip;
